export default class SemanticClasses {
	public static semanticTopic = 'semanticTopic';
	public static semanticTopicSelected = 'semanticTopicSelected';
	public static vocabularyRectangle = 'vocabularyRectangle';
}
